import ky from 'ky'
import type { UserInfo } from '@forest/native-services'
import type { SpecialChallengeConfig } from './special-challenge-model'

const mode = import.meta.env.MODE as 'production' | 'staging' | 'dev'

// One config file per cluster: the per-cluster lookup GLOSSARY.md#cluster asks
// for happens at the URL level, so the file holds a flat activity_id.
const configUrls: Record<UserInfo['server'], string> = {
  dev: 'https://forest-development-s3.seekrtech.com/special-challenge-config.json',
  staging:
    'https://forest-staging-s3.seekrtech.com/special-challenge-config.json',
  global: 'https://forest-s3.seekrtech.com/special-challenge-config.json',
  china: 'https://forest-s3.upwardsware.com/special-challenge-config.json',
}

function getConfigUrl(server: UserInfo['server']) {
  // Mirrors getServiceUrl in lib/api.ts: the Vite dev server owns the request
  // locally (MSW intercepts it under ?mock), non-production builds pin their
  // cluster, production resolves per user.
  if (import.meta.env.DEV)
    return `${location.origin}/special-challenge-config.json`
  if (mode === 'production') return configUrls[server]
  return mode === 'dev' ? configUrls.dev : configUrls.staging
}

export async function fetchSpecialChallengeConfig(
  server: UserInfo['server'],
): Promise<SpecialChallengeConfig> {
  return await ky(getConfigUrl(server)).json<SpecialChallengeConfig>()
}
